import React, { useEffect, useState, useMemo } from 'react';
import { withRouter } from "react-router-dom";
import Api from '../../Services/Api';
import DataTable from 'react-data-table-component';
import { getDateFormat } from '../../Services/Custom';
const Cusrrency = process.env.REACT_APP_CURRENCY_SYMBOL;

export const DeletedUsersList = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [isReset, setIsReset] = useState(0);

    const columns = useMemo(() => [
        {
            name: 'Name',
            selector: row => {
                let name = '-';
                if (row.firstname || row.lastname) {
                    name = (row.firstname || '') + ' ' + (row.lastname || '');
                }
                return name;
            },
        },
        {
            name: 'Mobile No.',
            selector: row => row.mobile_no || '-'
        },
        {
            name: 'Main Wallet',
            selector: row => (row.wallet_balance !== undefined && row.wallet_balance !== null) ? parseInt(row.wallet_balance) + Cusrrency : '0' + Cusrrency
        },
        {
            name: 'Winning Wallet',
            selector: row => (row.winning_wallet_balance !== undefined && row.winning_wallet_balance !== null) ? parseInt(row.winning_wallet_balance) + Cusrrency : '0' + Cusrrency
        },
        {
            name: 'Bonus Wallet',
            selector: row => (row.bonus_wallet_balance !== undefined && row.bonus_wallet_balance !== null) ? parseInt(row.bonus_wallet_balance) + Cusrrency : '0' + Cusrrency
        },
        {
            name: 'Deleted By',
            selector: row => {
                if (row.deleted_by_admin && row.deleted_by_admin.length > 0) {
                    return row.deleted_by_admin[0].username || row.deleted_by_admin[0].email || 'Admin';
                }
                return 'Unknown';
            }
        },
        {
            name: 'Deleted At',
            selector: row => row.createdAt ? getDateFormat(new Date(row.createdAt)) : '-'
        }
    ]);

    const fetchData = async (page) => {
        setLoading(true);
        const payload = { page: page, size: perPage, search: search };
        try {
            const response = await Api.post('user/deleted-list', payload);
            if (response.data.status) {
                setData(response.data.data.docs);
                setTotalRows(response.data.data.totalDocs);
            }
        } catch (error) {
            console.error("Error fetching deleted users:", error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = page => {
        fetchData(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setPerPage(newPerPage);
        // fetchData will be triggered by useEffect when perPage changes if we add it to deps, 
        // or we can call it here. Better to rely on the effect if we add dependencies, 
        // but explicit call is safer for now to match other data tables in this project.
        setLoading(true);
        const payload = { page: page, size: newPerPage, search: search };
        try {
            const response = await Api.post('user/deleted-list', payload);
            if (response.data.status) {
                setData(response.data.data.docs);
                setTotalRows(response.data.data.totalDocs);
            }
        } catch (e) { }
        setLoading(false);
    };

    const handleChangeSearch = (e) => {
        setSearch(e.target.value);
    };

    const handleFilter = () => {
        fetchData(1);
    };

    const handleResetFilter = () => {
        setSearch("");
        setIsReset(prev => prev + 1);
    };

    useEffect(() => {
        fetchData(1);
    }, [isReset]);

    return (
        <>
            <section className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title mb-4">Deleted Accounts and Wallet History</h4>
                                        <div className="row">
                                            <div className="col-lg-3 col-md-3">
                                                <input type="text" className="form-control" placeholder="Search by Name, Mobile..." value={search} onChange={handleChangeSearch} />
                                            </div>
                                            <div className="col-lg-3 col-md-3">
                                                <button type="button" className="btn btn-outline-primary mr-4 btn-sm btn-rounded waves-effect waves-light" onClick={handleFilter}>Filter</button>&nbsp;
                                                <button type="button" className="btn btn-outline-secondary mr-4 btn-sm btn-rounded waves-effect waves-light" onClick={handleResetFilter}>Reset</button>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            <DataTable
                                                columns={columns}
                                                data={data}
                                                progressPending={loading}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default withRouter(DeletedUsersList);
